import { render, staticRenderFns } from "./OrderSendPage.vue?vue&type=template&id=e14fd212&lang=pug"
import script from "./OrderSendPage.vue?vue&type=script&lang=js"
export * from "./OrderSendPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports